module.exports = __webpack_public_path__ + "img/sleeve cap back.66e0b130.png";